import { apiRequest } from '../utils/api';

const BASE = '/api/asset-id-templates';

export const fetchModuleCatalogue = () => apiRequest(`${BASE}/modules`);

export const listTemplates = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') qs.append(k, v); });
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return apiRequest(`${BASE}${suffix}`);
};

export const previewTemplate = (template, propertyCode = 'BRW') =>
  apiRequest(`${BASE}/preview`, { method: 'POST', body: JSON.stringify({ template, propertyCode }) });

export const createTemplate = (payload) =>
  apiRequest(`${BASE}`, { method: 'POST', body: JSON.stringify(payload) });

export const updateTemplate = (id, payload) =>
  apiRequest(`${BASE}/${id}`, { method: 'PUT', body: JSON.stringify(payload) });

export const deactivateTemplate = (id) =>
  apiRequest(`${BASE}/${id}/deactivate`, { method: 'POST' });
